var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-currency-field',_vm._b({class:_vm.classe,attrs:{"label":"","disabled":"","solo":"","dense":"","value":_vm.value},scopedSlots:_vm._u([{key:"append",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'v-currency-field',_vm.money,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }